import React, { createContext, useRef, useState } from 'react';
interface PagerContextInterface {
  currentPage: number;
  prevPage: () => void;
  nextPage: () => void;
  goToPage: (index: number) => void;
}

const PagerContext = createContext<PagerContextInterface | null>(null);
const DEFAULT_INIT_PAGE = 0;

const PagerProvider: React.FC<{
  initPage?: number;
}> = ({ children, initPage = DEFAULT_INIT_PAGE }) => {
  const [currentPage, setCurrentPage] = useState(initPage);

  const indexHistory = useRef<number[]>([]);

  const nextPage = () => {
    goToPage(currentPage + 1);
  };

  const prevPage = () => {
    const newPrevPage =
      indexHistory.current.length > 0 ? indexHistory.current.pop() : 0;
    setCurrentPage(newPrevPage!);
  };

  const goToPage = (index: number) => {
    setCurrentPage(index);
    indexHistory.current.push(currentPage);
  };

  const state = {
    currentPage,
    prevPage,
    nextPage,
    goToPage,
  };

  return (
    <PagerContext.Provider value={state}>{children}</PagerContext.Provider>
  );
};

export { PagerProvider, PagerContext };
